const selectors = {
    wrapper: '.js-cases-slider-parent',
    btn: '.js-cases-filter-btn',
    slider: '.js-cases-slider',
    slide: '.js-cases-slide'
};

const states = {
    isActive: 'is-active'
};

const ALL_CASES_ATTRIBUTE = 'all-cases';

const toggleActiveClass = ($elem, $this) => {
    $elem.find(`${selectors.btn}.${states.isActive}`).removeClass(states.isActive);
    $this.addClass(states.isActive);
};

const filteredCases = ($slider, dataAttr) => {
    $slider.slick('slickUnfilter');

    if (dataAttr === ALL_CASES_ATTRIBUTE) {
        $slider.slick('slickFilter', selectors.slide);
    } else {
        $slider.slick('slickFilter', $(`[data-case-category="${dataAttr}"]`));
    }
};

const onBtnClick = ($slider) => (evt) => {
    const $this = $(evt.currentTarget);
    const dataAttr = $this.data('case-filter');
    const $elem = $this.closest(selectors.wrapper);

    if ($this.hasClass(states.isActive)) {
        return;
    }

    toggleActiveClass($elem, $this);
    filteredCases($slider, dataAttr);
};

const casesFiltering = () => {
    const $wrapper = $(selectors.wrapper);
    const $slider = $(selectors.slider);

    if (!$wrapper.length) {
        return;
    }

    $wrapper.on('click', `${selectors.btn}`, onBtnClick($slider));
};

export default casesFiltering;
